/**
 * @file Contém enums referente ao ato
 */
const publicacao = {
    OK: 'OK',
    PENDENTE: 'Pendente',
    REPUBLICAR: 'Republicar',
}
    
export default {publicacao};
